import React, {useContext, useState} from "react";
import { NavLink } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import {
  faCaretDown,
} from "@fortawesome/free-solid-svg-icons";

import { useTranslation } from "react-i18next";
import RequestDataDeleteDialog from "./RequestDataDeleteDialog";
import InitContext from "../pages/InitContext";
import useMmcService from "../../services/MmcService";
import exampleRequest from "../../resources/json/healthLordRequestBodyExample.json";
import TestUploadButton from "../pages/TestUploadButton";

const NavigationBarForTablet = ({ onResetApp, onNavigate, isMobile }) => {
  const { t } = useTranslation();
  const context = useContext(InitContext);
  const { login, sendHealthLordRequest, getHealthLordResults, getHisPdmReportFile } = useMmcService();

  const [showRequestDataDeleteDialog, setShowRequestDataDeleteDialog] =
    useState(false);
  const [openSection, setOpenSection] = useState(null);
  const [pdmId, setPdmId] = useState(-1);
  const [showPdmIdDialog, setShowPdmIdDialog] = useState(false);
  const [hisOrderId, setHisOrderId] = useState("");
  const [showHisOrderDialog, setShowHisOrderDialog] = useState(false);

  const handleShowDeleteDataRequestDialog = () => {
    setShowRequestDataDeleteDialog(true);
  };

  const handleCancelRequestDataDelete = () => {
    setShowRequestDataDeleteDialog(false);
  };

  const handleRequestDataDeleteSubmitted = () => {
    setShowRequestDataDeleteDialog(false);
    onResetApp();
  };

  const handleToggleSection = (sectionId) => {
    setOpenSection((current) => (current === sectionId ? null : sectionId));
  };

  const handleSendHealthLordRequest = () => {
    const body = {
      name: "healthlord",
      password: "geheim"
    };

    login(body).then((token) => {
      sendHealthLordRequest(`bearer ${token?.token}`, exampleRequest).then();
    });
  };

  const handleGetHealthLordResults = () => {
    const body = {
      name: "healthlord",
      password: "geheim"
    };

    login(body).then((token) => {
      getHealthLordResults(`bearer ${token.token}`, hisOrderId).then(() => {
        setHisOrderId("");
        setShowHisOrderDialog(false);
      });
    });
  };

  const handleGetHealthLordResultFile = () => {
    const body = {
      name: "healthlord",
      password: "geheim"
    };

    login(body).then((token) => {
      getHisPdmReportFile(`bearer ${token.token}`, pdmId).then((result) => {
        setPdmId(-1);
        setShowPdmIdDialog(false);

        if (result) {
          const url = window.URL.createObjectURL(result.blob);
          const a = document.createElement("a");
          a.href = url;
          a.download = result.filename;
          document.body?.appendChild(a);
          a.click();
          a.remove();
        }
      });
    });
  };

  return (
    <div className={`w3-bar w3-theme-l3 app-nav ${isMobile ? "app-nav-accordion" : ""}`}>
      <NavLink to={`/drugsTab/`}
               onClick={onNavigate}
               className={({ isActive }) => isActive
                  ? "w3-bar-item w3-hover-light-blue w3-theme-d3 app-nav-item app-nav-item-active"
                  : "w3-bar-item w3-hover-light-blue app-nav-item"}>
        <label>{t("medication_plan")}</label>
      </NavLink>
      <div className={isMobile ? "app-nav-accordion-section" : "w3-dropdown-hover w3-theme-l3 app-nav-dropdown"}>
        <button
          className="w3-btn w3-theme-l3 w3-hover-light-blue app-nav-item app-nav-accordion-trigger"
          onClick={isMobile ? () => handleToggleSection("diary") : undefined}
          aria-expanded={isMobile ? openSection === "diary" : undefined}
          aria-controls={isMobile ? "nav-accordion-diary" : undefined}
        >
          <label>{t("diary")}</label> <FontAwesomeIcon icon={faCaretDown} />
        </button>
        <div
          id="nav-accordion-diary"
          className={`w3-dropdown-content w3-bar-block w3-theme-l3 w3-border app-nav-dropdown-content ${
            isMobile ? "app-nav-accordion-panel" : ""
          } ${isMobile && openSection === "diary" ? "is-open" : ""}`}
        >
          <NavLink
            to={`/symptoms/`}
            onClick={onNavigate}
            className={({ isActive }) =>
              isActive
                ? "w3-bar-item w3-hover-light-blue w3-theme-d3 app-nav-item app-nav-item-active"
                : "w3-bar-item w3-hover-light-blue app-nav-item"
            }
          >
            <label>{t("symptoms")}</label>
          </NavLink>
          <NavLink
            to={`/labValues/`}
            onClick={onNavigate}
            className={({ isActive }) =>
              isActive
                ? "w3-bar-item w3-hover-light-blue w3-theme-d3 app-nav-item app-nav-item-active"
                : "w3-bar-item w3-hover-light-blue app-nav-item"
            }
          >
            <label>{t("lab_values")}</label>
          </NavLink>
          <NavLink
            to={`/measurements/`}
            onClick={onNavigate}
            className={({ isActive }) =>
              isActive
                ? "w3-bar-item w3-hover-light-blue w3-theme-d3 app-nav-item app-nav-item-active"
                : "w3-bar-item w3-hover-light-blue app-nav-item"
            }
          >
            <label>{t("measurements")}</label>
          </NavLink>
        </div>
      </div>
      <div className={isMobile ? "app-nav-accordion-section" : "w3-dropdown-hover w3-theme-l3 app-nav-dropdown"}>
        <button
          className="w3-btn w3-theme-l3 w3-hover-light-blue app-nav-item app-nav-accordion-trigger"
          onClick={isMobile ? () => handleToggleSection("medication-info") : undefined}
          aria-expanded={isMobile ? openSection === "medication-info" : undefined}
          aria-controls={isMobile ? "nav-accordion-medication-info" : undefined}
        >
          <label>{t("medication_information")}</label>{" "}
          <FontAwesomeIcon icon={faCaretDown} />
        </button>
        <div
          id="nav-accordion-medication-info"
          className={`w3-dropdown-content w3-bar-block w3-theme-l3 w3-border app-nav-dropdown-content ${
            isMobile ? "app-nav-accordion-panel" : ""
          } ${isMobile && openSection === "medication-info" ? "is-open" : ""}`}
        >
          <NavLink
            to={`/pdir/`}
            onClick={onNavigate}
            className={({ isActive }) =>
              isActive
                ? "w3-bar-item w3-hover-light-blue w3-theme-d3 app-nav-item app-nav-item-active"
                : "w3-bar-item w3-hover-light-blue app-nav-item"
            }
          >
            <label>{t("medication_recommender")}</label>
          </NavLink>
          {context?.patient?.study_id?.toLowerCase() === "demo-hospital" && (
              <NavLink
                  to={`/pharmaOracle/`}
                  onClick={onNavigate}
                  className={({ isActive }) =>
                      isActive
                          ? "w3-bar-item w3-hover-light-blue w3-theme-d3 app-nav-item app-nav-item-active"
                          : "w3-bar-item w3-hover-light-blue app-nav-item"
                  }
              >
                <label>{t("pharma_oracle")}</label>
              </NavLink>
          )}
        </div>
      </div>
      <div className={isMobile ? "app-nav-accordion-section" : "w3-dropdown-hover w3-theme-l3 app-nav-dropdown"}>
        <button
          className="w3-btn w3-theme-l3 w3-hover-light-blue app-nav-item app-nav-accordion-trigger"
          onClick={isMobile ? () => handleToggleSection("profile") : undefined}
          aria-expanded={isMobile ? openSection === "profile" : undefined}
          aria-controls={isMobile ? "nav-accordion-profile" : undefined}
        >
          <label>{t("profile")}</label> <FontAwesomeIcon icon={faCaretDown} />
        </button>
        <div
          id="nav-accordion-profile"
          className={`w3-dropdown-content w3-bar-block w3-theme-l3 w3-border app-nav-dropdown-content ${
            isMobile ? "app-nav-accordion-panel" : ""
          } ${isMobile && openSection === "profile" ? "is-open" : ""}`}
        >
          {
            <NavLink
              to={`/patient/`}
              onClick={onNavigate}
              className={({ isActive }) =>
                isActive
                  ? "w3-bar-item w3-hover-light-blue w3-theme-d3 app-nav-item app-nav-item-active"
                  : "w3-bar-item w3-hover-light-blue app-nav-item"
              }
            >
              <label>{t("health")}</label>
            </NavLink>
          }
          <NavLink
            to={`/pgx/`}
            onClick={onNavigate}
            className={({ isActive }) =>
              isActive
                ? "w3-bar-item w3-hover-light-blue w3-theme-d3 app-nav-item app-nav-item-active"
                : "w3-bar-item w3-hover-light-blue app-nav-item"
            }
          >
            <label>{t("pgx")}</label>
          </NavLink>
          <button
            className="w3-bar-item w3-hover-light-blue app-nav-item"
            onClick={handleShowDeleteDataRequestDialog}
            disabled={context?.patient?.delete_requested === 1}
          >
            <label>{t("request_delete_my_data")}</label>
          </button>
          {/*<button
            className="w3-bar-item w3-hover-light-blue app-nav-item fa-test-color"
            onClick={handleSendHealthLordRequest}
          >
            FaTest: Send HealthLord request
          </button>
          <TestUploadButton />
          <button
            className="w3-bar-item w3-hover-light-blue app-nav-item fa-test-color"
            onClick={() => setShowHisOrderDialog(true)}
          >
            FaTest: Get HealthLord results
          </button>
          <button
            className="w3-bar-item w3-hover-light-blue app-nav-item fa-test-color"
            onClick={() => setShowPdmIdDialog(true)}
          >
            Get result file
          </button>*/}
        </div>
      </div>
      {/*showPdmIdDialog && (
        <div className="feedback-modal">
          <div className="feedback-modal-content">
            <header className="feedback-modal-header">
              <h2>Enter the PDM ID</h2>
            </header>
            <input
              type="text"
              value={pdmId}
              onChange={(e) => setPdmId(e.target.value)}
            />
            <div className="feedback-modal-buttons">
              <button onClick={handleGetHealthLordResultFile} className="w3-btn w3-round-xlarge w3-theme-d5">
                Retrieve PDF file
              </button>
              <button onClick={() => setShowPdmIdDialog(false)} className="w3-btn w3-round-xlarge w3-theme-d5">
                {t("cancel")}
              </button>
            </div>
          </div>
        </div>
      )}
      {showHisOrderDialog && (
        <div className="feedback-modal">
          <div className="feedback-modal-content">
            <header className="feedback-modal-header">
              <h2>Enter the HIS order ID</h2>
            </header>
            <input
              type="text"
              value={hisOrderId}
              onChange={(e) => setHisOrderId(e.target.value)}
              style={{ width: "40ch", padding: "8px", borderRadius: "4px" }}
            />
            <div className="feedback-modal-buttons">
              <button onClick={handleGetHealthLordResults} className="w3-btn w3-round-xlarge w3-theme-d5">
                Retrieve the results
              </button>
              <button onClick={() => setShowHisOrderDialog(false)} className="w3-btn w3-round-xlarge w3-theme-d5">
                {t("cancel")}
              </button>
            </div>
          </div>
        </div>
      )*/}
      {showRequestDataDeleteDialog && (
        <RequestDataDeleteDialog
          showDialog={showRequestDataDeleteDialog}
          onConfirmRequestDataDelete={handleRequestDataDeleteSubmitted}
          onCancelRequestDataDelete={handleCancelRequestDataDelete}
        />
      )}
    </div>
  );
};

export default NavigationBarForTablet;
